// src/components/FooterItem/FooterItem.js
import React from "react";
import { Layout, Typography } from "antd";

const { Footer } = Layout;

export default function FooterItem() {
  return (
    <Footer style={{ textAlign: "center" }}>
      <Typography.Text type="secondary">
        © {new Date().getFullYear()} my-blog-app — React + Ant Design
      </Typography.Text>
    </Footer>
  );
}
